<ng-template #defaultTemplate [lgChartTemplateContextType]="this" let-context>
    <table class="lg-chart__tooltip__table">
        @for (item of context.displayingItems; track item.lineChartItem) {
            <tr class="lg-chart__tooltip__table__item">
                <td class="lg-chart__tooltip__table__item__color_column">
                    @if (!item.showValueOnly) {
                        <span [style.background]="item.color"></span>
                    }
                </td>
                <td class="lg-chart__tooltip__table__item__name_column">
                    {{ item.showValueOnly ? "" : item.groupName + ":" }}
                </td>
                <td class="lg-chart__tooltip__table__item__value_column">
                    {{ _tooltipFormatter.format(item.value) }}
                </td>
            </tr>
        }
    </table>
</ng-template>

<ng-template #columnIconTemplate [lgChartTemplateContextType]="this" let-context>
    <table class="lg-chart__tooltip__table">
        @for (item of context.displayingItems; track item.lineChartItem) {
            <tr class="lg-chart__tooltip__table__item">
                <td class="lg-chart__tooltip__table__item__value_column">{{ item.text }}</td>
            </tr>
        }
    </table>
</ng-template>

<div
    #chartWithLegend
    class="lg-line-chart"
    [class.lg-line-chart--flex-row]="legendOptions.position === 'right'"
    [class.lg-line-chart--flex-column]="legendOptions.position === 'bottom'"
    [style.height.px]="height"
    [style.width.px]="width"
>
    <div #chart [style.visibility]="_data && _data.length ? 'visible' : 'hidden'"></div>

    @if (legendOptions.visible) {
        <lg-chart-legend
            [className]="legendOptions.className"
            [definition]="_legendDefinition"
            [position]="legendOptions.position"
            [cropLongNames]="legendOptions.cropLongNames ?? false"
            [wrapMultilineDefinition]="legendOptions.wrapMultilineDefinition ?? false"
            (mouseleave)="_onLegendItemLeave()"
            [width]="_legendWidth"
            [legendTemplate]="legendTemplate"
        >
        </lg-chart-legend>
    }
</div>

<ng-template #legendTemplate>
    @for (item of _legendDefinition; track item) {
        <span
            (mouseenter)="_onLegendItemHover(item.name)"
            (mouseleave)="_onLegendItemLeave()"
            class="lg-chart-legend__item lg-chart-legend__item--interactive lg-chart-legend__item--line-chart-custom"
        >
            <lg-chart-icon [symbol]="'line-with-circle'" [color]="item.color"></lg-chart-icon>
            <span class="lg-chart-legend__item__name">
                {{ item.name }}
            </span>
        </span>
    }
</ng-template>
